import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import VueRouter from 'vue-router'
import '@/assets/styles/custom-element.scss'
import router from '@/router'
import '@/assets/styles/index.css'
import htmlToPdf from '@/core/utils/pdf'

import 'mapbox-gl/dist/mapbox-gl.css'
import 'vue2-editor/dist/vue2-editor.css'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.bubble.css'
import 'quill/dist/quill.snow.css'

import 'default-passive-events'

// globally register svg icon
import SvgIcon from '@/components/common/SvgIcon' // svg component

// generate pdf pages

import store from '@/store'

/* add icons to the library */
Vue.use(htmlToPdf)

// register globally
Vue.component('svg-icon', SvgIcon)
const req = require.context('@/assets/svg', false, /\.svg$/)
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)

Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
